//门店资金管理api
import {ServerPriceApi} from '@/group-cloud/network/ServerBizApi';
//资金调整类型
export const Adjust_Fund_Opts = [
    {id: 1, label: '资金充值'},
    {id: 2, label: '资金扣款'}
];

//资金变动类型(往来类型)
export const Concat_Fund_Opts = [
    {id: '1', label: '资金充值'},
    {id: '2', label: '资金扣款'},
    {id: '3', label: '订单扣款'},
    {id: '4', label: '订单退款'},
    {id: '5', label: '转账充值'}
];
//门店类型（上架类型）：
export const Customer_Types_Opts = [
    // {id: 1, label: '总部'},
    {id: 2, label: '品类店'},
    {id: 5, label: '集合店'},
    {id: 14, label: '专柜店'},
    {id: 41, label: '专卖店'},
    {id: 75, label: '明星店'},
    {id: 421, label: '直营店'},
];
export class FundManageApi {

    constructor() {
    }
    protected static groupUrl = '/data-dist/api/money/center';
    // http://47.95.206.72:3001/mock/167/data-dist/api/money/center/loadPageFuzzy
    //查询资金列表信息
    public static async getFundList(data){
        let uri = this.groupUrl + '/loadPageFuzzy';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //查询门店银行账号列表
    public static async getFundSearch(data){
        let uri = this.groupUrl + '/cardInfo';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //转账充值记录
    public static async getFundRecharge(data){
        let uri = this.groupUrl + '/cardChargePage';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //查询资金往来列表
    public static async getFundExpenditure(data){
        let uri = this.groupUrl + '/moneyRecord';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //资金转账导入
    public static async importFundTransfer(data){
        let uri = this.groupUrl + '/';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //关闭资金账户
    public static async closeFundAccount(data){
        let uri = this.groupUrl + '/changeStats';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //资金账户调整
    public static async adjustFund(data){
        let uri = this.groupUrl + '/handleChangeMoneyAccount';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //保存银行信息
    public static async saveBankInfo(data){
        let uri = this.groupUrl + '/modifyBankCard';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //门店资金管理
    public static async editManageAccount(data){
        let uri = this.groupUrl + '/editManageAccount';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //门店调整账户状态
    public static async changeStats(data){
        let uri = this.groupUrl + '/changeStats';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
}


